/** Trigger a browser download of `data` as pretty-printed JSON. */
export function downloadJson(data: unknown, baseName: string): void {
	const blob = new Blob([JSON.stringify(data, null, 2)], {
		type: "application/json",
	});
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = `${baseName}-${new Date().toISOString().slice(0, 10)}.json`;
	document.body.append(a);
	a.click();
	a.remove();
	URL.revokeObjectURL(url);
}
